import commonConfig from "@host/host-configurations/common.yml";
import deepMerge from "./deepMerge";

export default function readHostConfig(hostFile: string): HostConfiguration {
  const outletConfig = require(`@host/host-configurations/${hostFile}.yml`);
  const config = deepMerge(commonConfig, outletConfig);

  return JSON.parse(JSON.stringify(config));
}
